
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
export default {
 name:"klsz",
 components: {
   CommonTitle,
   BannerTop,
   // Notice
 },
 computed: {
  contentList () {
      return this.$t('news.klsz.contentList')
    },
 },
 data() {
  return {
    bannerUrl:require("~/static/images/news/banner.png"),
    imageList: [
      {
        id: 1,
        src: require(`@/static/images/news/klsz/1.png`)
      },
      {
        id: 2,
        src: require(`@/static/images/news/klsz/2.png`)
      },
      {
        id: 3,
        src: require(`@/static/images/news/klsz/3.png`)
      },
    ],
  }
 },
}
